<template>
  <section class="q-home-grid">
    <div class="container">
      <p class="q-section-title">Últimos agregados</p>

      <div v-if="products && products.length > 0">
        <div class="row row-cols-2 row-cols-sm-2 row-cols-md-3 row-cols-lg-4 g-3">
          <div
            v-for="product in products"
            :key="product.id"
            class="col q-fade-up"
          >
            <ProductCard :product="product" />
          </div>
        </div>
        <div class="mt-4">
          <GridPagination />
        </div>
      </div>

      <div v-else class="q-empty-state">
        <i class="bi bi-grid q-empty-state__icon"></i>
        <p class="q-empty-state__text">No hay productos disponibles</p>
      </div>
    </div>
  </section>
</template>

<script>
import ProductCard    from "./Product-card";
import GridPagination from "../components/gridProducts/GridPagination.vue";
import { mapGetters, mapActions, mapMutations } from "vuex";

export default {
  components: { ProductCard, GridPagination },

  created() { this.newProducts(); },

  beforeDestroy() {
    this.setPageNumber(1);
    this.setSortMethod("abc");
    this.setProducts([]);
  },

  computed: {
    ...mapGetters({ products: "ecommerce/products" }),
  },

  methods: {
    ...mapActions({ loadProducts: "ecommerce/loadProducts" }),
    ...mapMutations({
      setPageNumber: "ecommerce/SET_PAGE_NUMBER",
      setProducts:   "ecommerce/SET_PRODUCTS",
      setSortMethod: "ecommerce/SET_SORT_METHOD",
    }),
    newProducts() {
      this.setSortMethod("new");
      this.setPageNumber(1);
      this.loadProducts();
    },
  },
};
</script>

<style scoped>
.q-home-grid {
  padding: 40px 0 60px;
  border-top: 1px solid var(--q-border);
}
.q-empty-state {
  display: flex; flex-direction: column;
  align-items: center; justify-content: center;
  padding: 60px 20px; text-align: center;
}
.q-empty-state__icon { font-size: 2.5rem; color: var(--q-text-subtle); margin-bottom: 12px; }
.q-empty-state__text {
  font-family: var(--q-font-display); font-size: 12px; font-weight: 600;
  letter-spacing: 0.08em; text-transform: uppercase; color: var(--q-text-subtle); margin: 0;
}
</style>
